function fakePhoneFromPrefix(s: string) {
  let targetDigits = 10;
  const currentDigits = (s.match(/\d/g) || []).length;
  const intlPrefix = s.match(/^\+?0?(1|$)/)?.[0] ?? '';
  if (intlPrefix.length) {
    targetDigits = intlPrefix.includes('0') ? 12 : 11;
  }
  const zeroes = '15558675309';
  const neededDigits = targetDigits - currentDigits;
  return `${s}${zeroes.slice(-neededDigits)}`;
}

// https://stackoverflow.com/a/16699507/8107589
const rePhoneNumber = /^(\+0?1|0?1)?[.-]?\(?[2-9]\d{2}\)?[.-]?\d{3}[.-]??\d{4}$/;

export function isPhoneNumber(s: string) {
  return rePhoneNumber.test(s.replace(/ /g, ''));
}

export function validatePhoneNumber(s: string) {
  const compact = s.replace(/ /g, '');
  if (rePhoneNumber.test(compact)) {
    return 'valid';
  } else if (rePhoneNumber.test(fakePhoneFromPrefix(compact))) {
    return 'prefix';
  } else {
    return 'invalid';
  }
}

export type PhoneNumberFormat = 'local' | 'e164';

// TODO: Validate, too?
export function normalizePhoneNumber(s: string, format: PhoneNumberFormat = 'local') {
  const digits = (s.match(/\d/g) || []).join('');
  let i = 0;
  if (digits.at(i) === '0') {
    i += 1;
  }
  if (digits.at(i) === '1') {
    i += 1;
  }
  switch (format) {
    case 'local':
      return `(${digits.slice(i, i + 3)}) ${digits.slice(i + 3, i + 6)}-${digits.slice(i + 6)}`;
    case 'e164':
      return `+1${digits.slice(i)}`;
  }
}
